// extracted by mini-css-extract-plugin
module.exports = {"root":"OkIcon_root__1SQB7"};